import type { CustomNode, CustomEdge } from '@src/components/custom-nodes/types';

export const getPrecededNodes = (node: CustomNode, nodes: CustomNode[], edges: CustomEdge[]) => {
  const precededNodes: CustomNode[] = [];

  function traverseNodesUp(nodeId: string) {
    const parentNodeId = edges.find((edge) => edge.target === nodeId)?.source;
    const parentNode = nodes.find((node) => node.id === parentNodeId)!;

    if (parentNodeId) {
      precededNodes.push(parentNode);
      traverseNodesUp(parentNodeId);
    }
  }

  traverseNodesUp(node.id);

  return precededNodes;
};
